<template>
  <div class="TeacherManagement">
    <el-form ref="form" label-width="80px">
      <el-row style="margin-top: 20px">
        <el-col :span="4">
          <el-form-item label="账号">
            <el-input v-model.trim="useraccount" placeholder="请输入账号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="手机号">
            <el-input v-model.trim="userphone" placeholder="请输入手机号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="昵称">
            <el-input v-model.trim="userrealname" placeholder="请输入昵称"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span='5'>
					<el-form-item label="状态">
						<el-select v-model="userstate" placeholder="请选择状态">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col> -->
        <el-col :span="4">
          <el-form-item label="身份">
            <el-select v-model="rolt" placeholder="请选择" clearable>
              <el-option v-for="item in roloptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2" :offset="6">
          <el-button type="primary" @click="seetabke('see')">查询</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-row style="margin-bottom: 10px">
      <el-col style="padding-left: 76%">
        <!-- <el-button plain type="success" size='medium' @click='isToExamine(1)'>审核通过</el-button> -->
        <!-- <el-button plain type="primary" size='medium' @click='isToExamine(2)'>审核不通过</el-button> -->
        <el-button plain type="danger" size="medium" @click="belects()">移除</el-button>
        <el-button plain type="primary" size="medium" @click="editsPass()">修改密码</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border style="width: 90%; margin: 0 auto" max-height="580px"
          @selection-change="selectionLineChangeHandle" v-loading="loading">
          <el-table-column type="selection" align="center"> </el-table-column>
          <el-table-column prop="id" label="账户ID" align="center">
          </el-table-column>
          <el-table-column prop="realname" label="真实姓名" align="center">
          </el-table-column>
          <el-table-column prop="account" label="账号" align="center">
          </el-table-column>
          <el-table-column prop="phone" label="手机号" align="center">
          </el-table-column>
          <el-table-column prop="gender" label="性别" align="center">
          </el-table-column>
          <el-table-column prop="type_role" label="身份" align="center">
          </el-table-column>
          <el-table-column prop="state" label="状态" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="400">
            <template slot-scope="scope">
              <el-row>
                <el-col>
                  <!-- scope.row -->
                  <!-- {{scope.row}} -->
                  <!-- <el-button plain type="success" size='mini' @click='danisToExamine(1,scope.row)'
										v-show="scope.row.state!='审核通过'">审核通过</el-button> -->
                  <!-- <el-button plain type="primary" size='mini' @click='danisToExamine(2,scope.row)'
										v-show="scope.row.state!='审核未通过'">审核不通过</el-button> -->
                  <el-button plain type="danger" size="mini" @click="danbelects(scope.row)">移除</el-button>
                  <el-button plain type="primary" size="mini" @click="editPass(scope.row)">修改密码</el-button>
                  <el-button plain @click="see(scope.row)" type="primary" size="mini">信息查看</el-button>
                  <el-button plain v-if="scope.row.type_role == '老师'||scope.row.type_role == '管理员'&&(session && (session.organization_id==497||session.organization_id==12173||session.organization_id==13344) )" @click="setschooladmin(scope.row)" type="primary"
                    size="mini">{{scope.row.type_role == '管理员'?'取消设置管理员':'设置为教师管理员'}}</el-button>


                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="radioData" :total="allpage" style="margin-left: calc(5%); margin-top: 20px"
          :page-sizes="[15, 30, 50, 100]" @size-change="handleSizeChange" :current-page="page">
        </el-pagination>
      </el-col>
    </el-row>

    <el-dialog title="修改密码" :visible.sync="isShowEdit" width="30%" @close="inputPass = ''">
      <span style="display: flex; align-items: center"><span style="width: 115px">密码修改为：</span>
        <el-input v-model.trim="inputPass" placeholder="请输入密码"></el-input>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowEdit = false">取 消</el-button>
        <el-button type="primary" @click="passTrue()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="用户账号信息查看" :visible.sync="isSee" width="30%">
      <div v-if="accountInfo" style="margin-left: 50px">
        <div>最后登录地：{{ accountInfo.last_login_place }}</div>
        <div style="margin: 20px 0">常用登录地：{{ accountInfo.near_login_place }}</div>
        <div>号码归属地：{{ accountInfo.belong_place }}</div>
      </div>

    </el-dialog>
    <el-dialog title="删除所选账号：" :visible.sync="isDel" width="30%" @close="delData = null">
      <div>
        <div style="margin: 20px">
          1、所选账号相关任务书查看、作答、成绩分析将全部清除;
        </div>
        <div style="margin: 20px">
          2、所选账号相关班级、签到、笔记等信息将全部清除
        </div>
        <div style="color: red;margin: 20px">
          删除后所有数据无法找回，请谨慎选择。
        </div>
        <div style="color: red;margin: 20px">
          是否确定？
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="isDel = false">取 消</el-button>
          <el-button type="primary" @click="delTrue()">确 定</el-button>
        </span>


      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  account_teacher_list,
  account_teacher_audit,
  account_teacher_remove,
} from "../assets/js/network/network.js";
export default {
  components: {},
  data() {
    return {
      isDel: false,
      delData: null,
      isSee: false,
      accountInfo: null,
      isShowEdit: false,
      inputPass: '',
      user: '',
      selection: [],
      radioresource: "",
      timvalue: null,
      tableData: [],
      //分页显示条数
      pagesize: null,
      //所以资源条数
      allpage: null,
      //分页显示当前页面
      current_page: 1,
      page: 1,
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "审核通过",
        },
        {
          value: 2,
          label: "审核未通过",
        },
        {
          value: 0,
          label: "待审核",
        },
      ],
      roloptions: [
        {
          value: 1,
          label: "学生",
        },
        {
          value: 2,
          label: "老师",
        },
      ],
      useraccount: "",
      userphone: "",
      userrealname: "",
      userstate: "",
      rolt: "",
      loading: true,
      radioData: 15,
      session:null
    };
  },
  methods: {
    setschooladmin(item) {
      this.$post(this.$api.account_set_schooladmin, { account_id: item.id, status: item.type_role == '管理员' ? 0 : 1 }).then(res => {

        if(res.code==0){
          this.init();
          this.$message.success('操作成功')
        }

      })
    },
    see(v) {
      this.isSee = true
      this.$get(this.$api.accountAddressInfo, { user_id: v.id }).then(res => {
        if (res.code == 0) {
          this.accountInfo = res.ret
        }
      })
    },
    handleSizeChange(val) {
      this.radioData = val;
      this.seetabke();
    },
    handleCurrentChange(val) {
      this.page = val;
      console.log(this.page);
      this.seetabke();
    },
    isToExamine(state) {
      let selectionarray = [];
      for (let i = 0; i < this.selection.length; i++) {
        selectionarray.push({
          account_id: this.selection[i].id,
        });
      }
      let data = {
        state,
        value_array: selectionarray,
      };
      account_teacher_audit(data).then((res) => {
        if (res.code == 0) {
          this.seetabke();
        }
      });
    },
    editPass(v) {
      console.log(v)
      if (v.account) {
        this.user = v.account
      } else if (v.phone) {
        this.user = v.phone
      }
      this.isShowEdit = true

    },
    editsPass() {
      this.user = ''
      if (this.selection.length == 0) {
        this.$message.warning('请勾选数据')
        return
      }
      this.isShowEdit = true
    },
    passTrue() {
      let reg = /^[^\u4e00-\u9fa5]{6,15}$/;  //正则使用方式 reg.test("内容")
      if (!reg.test(this.inputPass)) {
        //如果为true,则代表内容中有汉字
        this.$message.error("密码6-15位并且不能包含汉字")
        return
      }
      if (this.user != "") {
        let data = {
          value_array: [{ user: this.user }],
          password: this.$md5(this.inputPass),
        }
        this.$post(this.$api.accountsPasswordReset, data).then(res => {
          if (res.code == 0) {
            this.isShowEdit = false
            this.seetabke();
            this.$message.success("修改密码成功")
          }
        })
      } else {
        let data = {
          value_array: [],
          password: this.$md5(this.inputPass),
        }
        this.selection.forEach(item => {
          if (item.account) {
            data.value_array.push({ user: item.account })
          } else if (item.phone) {
            data.value_array.push({ user: item.phone })
          } else if (item.email) {
            data.value_array.push({ user: item.email })
          }
        })
        // console.log(123,data)
        this.$post(this.$api.accountsPasswordReset, data).then(res => {
          if (res.code == 0) {
            this.isShowEdit = false
            this.seetabke();
            this.$message.success("修改密码成功")
          }
        })
      }
    },
    delTrue() {

      account_teacher_remove({ value_array: this.delData.value_array }).then((res) => {
        if (res.code == 0) {
          this.$message.success('移除成功')
          this.seetabke();
          this.delData = null
          this.isDel = false
        }
      });
    },
    belects() {
      if (this.selection.length == 0) {
        this.$message.warning('请勾选数据')
        return
      }


      let selectionarray = [];
      for (let i = 0; i < this.selection.length; i++) {
        selectionarray.push({
          account_id: this.selection[i].id,
        });
      }

      this.delData = {
        value_array: selectionarray,
      }
      this.isDel = true
      // this.$confirm('您确定删除该数据吗?')
      //   .then(_ => {
      //     account_teacher_remove(data).then((res) => {
      //       if (res.code == 0) {
      //         this.seetabke();
      //       }
      //     });
      //   })
    },
    danbelects(item) {
      let data = {
        value_array: [
          {
            account_id: item.id,
          },
        ],
      };
      this.delData = {
        value_array: [
          {
            account_id: item.id,
          },
        ],
      }
      this.isDel = true
      // this.$confirm('您确定删除该数据吗?')
      //   .then(_ => {
      //     account_teacher_remove(data).then((res) => {
      //       if (res.code == 0) {
      //         this.$message.success('移除成功')
      //         this.seetabke();
      //       }
      //     });
      //   })
    },
    danisToExamine(state, item) {
      let data = {
        state,
        value_array: [
          {
            account_id: item.id,
          },
        ],
      };
      account_teacher_audit(data).then((res) => {
        if (res.code == 0) {
          this.seetabke();
        }
      });
    },
    selectionLineChangeHandle(v) {
      console.log(v)
      this.selection = v;
    },
    seetabke(see = null) {
      console.log(see);
      let data = {
        account: this.useraccount,
        phone: this.userphone,
        realname: this.userrealname,
        state: this.userstate,
        type_role: this.rolt,
        paginate: this.radioData
      };
      if (see == "see") {
        this.page = 1;
      }
      this.loading = true;
      // console.log(data)
      // console.log( this.page)
      account_teacher_list(data, this.page).then((res) => {
        for (let i = 0; i < res.ret.data.length; i++) {
          res.ret.data[i].phone = res.ret.data[i].phone ? res.ret.data[i].phone : '暂无'
          res.ret.data[i].account = res.ret.data[i].account ? res.ret.data[i].account : '暂无'
          res.ret.data[i].gender = res.ret.data[i].gender == 0 ? "女" : "男";
          res.ret.data[i].type_role =
            res.ret.data[i].type_role == 1 ? "学生" : (res.ret.data[i].type_role == 3 ? "管理员" : "老师");
          if (res.ret.data[i].state == 1) {
            res.ret.data[i].state = "审核通过";
          } else if (res.ret.data[i].state == 2) {
            res.ret.data[i].state = "审核未通过";
          } else if (res.ret.data[i].state == 0) {
            res.ret.data[i].state = "待审核";
          }
        }
        this.tableData = res.ret.data;
        // this.pagesize = res.ret.per_page;
        this.allpage = res.ret.total;
        this.current_page = res.ret.current_page;
        this.loading = false;
      });
    },
    init() {
      let data = {};
      account_teacher_list(data, this.page).then((res) => {
        for (let i = 0; i < res.ret.data.length; i++) {
          res.ret.data[i].phone = res.ret.data[i].phone ? res.ret.data[i].phone : '暂无'
          res.ret.data[i].account = res.ret.data[i].account ? res.ret.data[i].account : '暂无'
          res.ret.data[i].gender = res.ret.data[i].gender == 0 ? "女" : "男";
          res.ret.data[i].type_role =
            res.ret.data[i].type_role == 1 ? "学生" : (res.ret.data[i].type_role == 3 ? "管理员" : "老师");
          if (res.ret.data[i].state == 1) {
            res.ret.data[i].state = "审核通过";
          } else if (res.ret.data[i].state == 2) {
            res.ret.data[i].state = "审核未通过";
          } else if (res.ret.data[i].state == 0) {
            res.ret.data[i].state = "待审核";
          }
        }
        this.tableData = res.ret.data;
        //   this.pagesize = res.ret.per_page;
        this.allpage = res.ret.total;
        this.current_page = res.ret.current_page;
        this.loading = false;
      });
    }
  },

  mounted() {
    this.init();
    this.session=JSON.parse(localStorage.getItem('session'))
  },
};
</script>
<style scoped>
@import "../style/common.css";
</style>
